import * as React from "react";
import { Context } from "@grandvisionhq/carts-v2";
import { useGetShippingMethods } from "@grandvisionhq/shipping";
const useShippingMethodsList = (onShippingMethodsLoadCompleted, onError) => {
  const { cart } = Context.useCart();
  const onShippingMethodsLoadError = (errorResponse) => {
    console.error(`query:[shippingMethodForCart]: unable to load shipping methods`, errorResponse);
    onError?.("MUTATION");
  };
  const [loadShippingMethods, { called, data: shippingMethodList, loading, error }] = useGetShippingMethods({
    onError: onShippingMethodsLoadError,
    onCompleted: onShippingMethodsLoadCompleted
  });
  React.useEffect(() => {
    if (cart?.id && !called) {
      loadShippingMethods(cart?.id, cart?.prices.totalPrice);
    }
  }, [loadShippingMethods, called, cart]);
  const reloadShippingMethods = React.useCallback(() => {
    if (cart?.id && !called) {
      loadShippingMethods(cart?.id, cart?.prices.totalPrice);
    }
  }, [called, cart?.id, cart?.prices.totalPrice, loadShippingMethods]);
  return {
    shippingMethodList,
    reloadShippingMethods,
    isLoading: loading,
    error,
    called
  };
};
export {
  useShippingMethodsList
};
//# sourceMappingURL=use-shipping-methods-list.js.map
